import React, {Component} from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';
import {connect} from 'react-redux';
import {LOGIN_TO} from '~/constant/login';
import layoutModel from '~/model/layout';
import {isAbsolutePath} from '~/utils/url';
import {login, loginPwd, loginPhone, loginQrCode} from '~/service/login';
import H5Login from './H5Login';
import WebLogin from './WebLogin';

// 当前页面是
const TABS = {
    PWD: 0,
    QR: 1
};
class Login extends Component {
    constructor(props) {
        super(props);
        this.mounted = false;
        const {location: {search = ''}} = props;
        const queryParams = qs.parse(search.substr(1));
        const {service} = queryParams;
        // 缓存search, 给后端发请求时拼在url上
        this.search = search;
        // 缓存service, 用于判断是否有跳转地址
        this.service = service;
        this.state = {
            // /cas/bg/login后端返回的可能字段
            to: '',
            lt: '',
            execution: '',
            _eventId: '',
            token: '',
            tokenPhone: '',
            isNeedToVerify: false,
            captchaId: '',
            phone: '',
            code: '',
            errMsg: '',
            supportQRCode: 0,
            loginTab: TABS.PWD,
        };
    }

    componentDidMount = () => {
        // 避免内存泄漏
        this.mounted = true;
        // 预先查询登录流程, 判断是否直接跳转到子系统
        login({
            data: {},
            search: this.search
        })
            .then(loginRes => {
                const {data = {}} = loginRes;
                this.handleLoginRes(data);
            })
            .catch(loginErr => {
                const {msg = ''} = loginErr;
                this.setState({errMsg: msg});
            });
    };

    componentWillUnmount = () => {
        // 避免内存泄漏
        this.mounted = false;
    };

    // loginForm 设置错误信息回调
    setErrMsg = errMsg => {
        this.setState({errMsg});
    };

    // 登录状态: 重定向
    loginRedirect = next => {
        const {history} = this.props;
        // 企业微信登录会返回完整url
        if (isAbsolutePath(next)) {
            window.location.href = next;
        }
        // 登录流程重置, 会返回相对路径
        else {
            history.replace(next);
            location.reload();
        }
    };

    // 登录状态: 存在错误
    loginError = data => {
        const {history} = this.props;
        // 当查询到状态时已登录, 要跳转到子系统, 就不渲染, 直接跳转到子系统
        const {layout: {shouldRender}, dispatch} = this.props;
        if (!shouldRender) {
            dispatch(layoutModel.updateShouldRender(true));
        }
        history.push(`/cas/accessError${this.search}`, data);

    };

    // 登录状态: 成功
    loginSuccess = (next, data, errMsg = '') => {
        // 跳转到子系统
        if (next) {
            window.location.href = next;
        }
        // 显示登录成功界面
        else if (this.mounted) {
            // 当查询到状态时已登录, 要跳转到子系统, 就不渲染, 直接跳转到子系统
            const {layout: {shouldRender}, dispatch} = this.props;
            if (!shouldRender) {
                dispatch(layoutModel.updateShouldRender(true));
            }
            this.setState({...data, errMsg});
        }
    };

    // 统一处理登录接口返回数据
    handleLoginRes = data => {
        const {to, next, tip} = data;
        // 重新设置cookie时
        if (to === LOGIN_TO.REDIRECT) {
            this.loginRedirect(next);
        }
        // 未授权应用
        else if (to === LOGIN_TO.ERROR) {
            this.loginError(data);
        }
        // 登录成功
        else if (to === LOGIN_TO.LOGIN_SUCCESS) {
            this.loginSuccess(next, data, tip);
        }
        else if (to === LOGIN_TO.ACCOUNT_PASSWORD || to === LOGIN_TO.PHONE_CODE) {
            // 当查询到状态时已登录, 要跳转到子系统, 就不渲染, 直接跳转到子系统
            const {layout: {shouldRender}, dispatch} = this.props;
            if (!shouldRender) {
                dispatch(layoutModel.updateShouldRender(true));
            }
            this.setState({...data, errMsg: tip});
        }
        else {
            this.setState({...data, errMsg: tip});
        }
    };

    // 账号密码登录
    loginViaAccountPassport = ({username, password, code}) => {
        const {lt, token, execution, _eventId} = this.state;
        loginPwd({data: {lt, token, execution, _eventId, username, password, code}, search: this.search})
            .then(loginRes => {
                const {data = {}} = loginRes;
                this.handleLoginRes(data);
            })
            .catch(loginErr => {
                const {msg = ''} = loginErr;
                this.setState({errMsg: msg});
            });
    };

    // 手机安全验证
    loginViaPhoneSmsCode = ({smsCode}) => {
        const {tokenPhone, execution, _eventId, code} = this.state;
        loginPhone({data: {execution, _eventId, tokenPhone, code, smsCode}, search: this.search})
            .then(loginRes => {
                const {data = {}} = loginRes;
                this.handleLoginRes(data);
            })
            .catch(loginErr => {
                const {msg = ''} = loginErr;
                this.setState({errMsg: msg});
            });
    };

    // 扫码登录
    loginViaQrCode = ({qrcodeId}) => {
        const {lt, token, execution} = this.state;
        loginQrCode({data: {lt, token, execution, _eventId: 'qrCode', qrcodeId}, search: this.search})
            .then(loginRes => {
                const {data = {}} = loginRes;
                this.handleLoginRes(data);
            })
            .catch(loginErr => {
                const {msg = ''} = loginErr;
                this.setState({errMsg: msg});
            });
    };

    // 获取当前状态登录接口
    getLoginFunc = to => {
        const {loginTab} = this.state;
        if (to === LOGIN_TO.ACCOUNT_PASSWORD) {
            if (loginTab === TABS.PWD) {
                return this.loginViaAccountPassport;
            }
            if (loginTab === TABS.QR) {
                return this.loginViaQrCode;
            }
        }
        if (to === LOGIN_TO.PHONE_CODE) {
            return this.loginViaPhoneSmsCode;
        }
        return this.loginViaAccountPassport;
    };

    handleTabChange = () => {
        const {loginTab} = this.state;
        this.setState({loginTab: loginTab === TABS.PWD ? TABS.QR : TABS.PWD});
    };

    render() {
        const {to} = this.state;
        const {layout: {shouldRender}, agent: {isMobile}} = this.props;
        // 如果没有流程标记或者不允许渲染时, 返回空
        if (!to || !shouldRender) {
            return null;
        }
        const loginFunc = this.getLoginFunc(to);
        return isMobile
            ? <H5Login {...this.props} {...this.state} setErrMsg={this.setErrMsg} loginFunc={loginFunc} />
            : (
                <WebLogin
                    {...this.props}
                    {...this.state}
                    setErrMsg={this.setErrMsg}
                    loginFunc={loginFunc}
                    onTabChange={this.handleTabChange}
                />
            );
    }
}

Login.propTypes = {
    location: PropTypes.shape({
        search: PropTypes.string.isRequired,
    }).isRequired,
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
        replace: PropTypes.func.isRequired,
    }).isRequired,
    agent: PropTypes.shape({
        isMobile: PropTypes.bool.isRequired
    }).isRequired,
    layout: PropTypes.shape({
        shouldRender: PropTypes.bool.isRequired,
    }).isRequired,
    dispatch: PropTypes.func.isRequired,
};
export default connect(({agent, layout}) => ({agent, layout}))(Login);
